/* ===========================================================================
   Page épisode de podcast — façade vidéo et navigation par horodatage.
   ---------------------------------------------------------------------------
   Deux choses, et rien de plus :

   1. LA FAÇADE. Un iframe YouTube pose plusieurs centaines de kilo-octets et
      une dizaine de requêtes tierces sur chaque page épisode, avant même
      qu'on ait cliqué. Tant que personne ne clique, on n'affiche qu'une
      image et un bouton. L'iframe est construit au premier clic seulement.

   2. LES HORODATAGES. Les points clés sont de VRAIS liens vers la vidéo au
      bon moment : sans JS ils ouvrent YouTube, ce qui est un repli correct.
      Avec JS, si le lecteur est déjà ouvert sur la page, on le repositionne
      au lieu de quitter la page.

   Aucun SDK YouTube : le repositionnement se fait en reconstruisant l'URL
   d'embed avec le nouveau `start`. C'est moins fin qu'une API de lecture,
   mais ça ne charge pas 100 ko de script pour déplacer un curseur.
   =========================================================================== */
(function () {
  'use strict';

  var PARAMS = 'autoplay=1&rel=0&modestbranding=1&playsinline=1';

  function construitIframe(video, secondes, titre) {
    var iframe = document.createElement('iframe');
    var url = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(video) + '?' + PARAMS;
    if (secondes > 0) url += '&start=' + secondes;
    iframe.src = url;
    iframe.title = titre || 'Lecteur vidéo';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.loading = 'lazy';
    return iframe;
  }

  function ouvre(facade, secondes) {
    var video = facade.getAttribute('data-video');
    if (!video) return null;

    var bouton = facade.querySelector('[data-mm-facade-btn]');
    var iframe = facade.querySelector('iframe');

    if (iframe) {
      /* Déjà ouvert : on remplace la source pour repartir au bon moment.
         Recréer le nœud plutôt que réécrire src évite le cas où le
         navigateur ignore un changement de query sur une même origine. */
      var neuf = construitIframe(video, secondes, facade.getAttribute('data-titre'));
      iframe.replaceWith(neuf);
      return neuf;
    }

    if (bouton) bouton.remove();
    facade.classList.add('is-joue');
    var cree = construitIframe(video, secondes, facade.getAttribute('data-titre'));
    facade.insertBefore(cree, facade.firstChild);
    return cree;
  }

  function init() {
    var facade = document.querySelector('[data-mm-facade]');

    if (facade) {
      var bouton = facade.querySelector('[data-mm-facade-btn]');
      if (bouton) {
        bouton.addEventListener('click', function () {
          ouvre(facade, 0);
        });
      }
    }

    /* Les liens d'horodatage restent des liens : on n'intercepte que si le
       lecteur est là pour prendre le relais, et on laisse passer les clics
       modifiés (nouvel onglet) comme n'importe quel lien du site. */
    document.querySelectorAll('[data-mm-seek]').forEach(function (lien) {
      lien.addEventListener('click', function (e) {
        if (!facade) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        var secondes = parseInt(lien.getAttribute('data-mm-seek'), 10);
        if (isNaN(secondes)) return;
        e.preventDefault();
        var iframe = ouvre(facade, secondes);
        if (iframe) iframe.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
